import { confirmRegex } from '../constants';
import getDateTime from './getDateTime';
export var isFieldRequired = function (config) {
    var _a;
    var isInRequired = (_a = config.values.requiredValues) === null || _a === void 0 ? void 0 : _a.includes(config.key);
    return isInRequired !== null && isInRequired !== void 0 ? isInRequired : config.rule.required;
};
export var isFieldFocused = function (config) {
    var ref = config.refs.current[config.key];
    return document.activeElement === ref;
};
export var isFileFromServer = function (config) {
    var isRequired = isFieldRequired(config);
    return config.values[config.key + "Path"] && isRequired && !config.value;
};
export var isFile = function (config) {
    var isRequired = isFieldRequired(config);
    return !(isRequired && !config.value);
};
export var isDateBefore = function (config) {
    var rule = config.rule;
    return !(config.value && (rule.dateType === 'date' || !rule.dateType) && config.value > rule.before);
};
export var isDateAfter = function (config) {
    var rule = config.rule;
    return !(config.value && (rule.dateType === 'date' || !rule.dateType) && config.value < rule.after);
};
export var isTimeBefore = function (config) {
    var rule = config.rule;
    return !(config.value && getDateTime(rule.dateType === 'timeRange' ? config.value[1] : config.value) > getDateTime(rule.before));
};
export var isTimeAfter = function (config) {
    var rule = config.rule;
    return !(config.value && getDateTime(rule.dateType === 'timeRange' ? config.value[0] : config.value) < getDateTime(rule.after));
};
export var isTimeMinRange = function (config) {
    var rule = config.rule;
    return !(config.value && ((new Date(config.value[1]).getHours() - new Date(config.value[0]).getHours()) < rule.minHourRange));
};
export var isStringGreaterThan = function (config) {
    var _a, _b, _c, _d;
    var rule = config.rule;
    return !(config.value && typeof config.value === 'string' && ((_c = (_b = (_a = config.value) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) < ((_d = rule.greaterThan) !== null && _d !== void 0 ? _d : -1));
};
export var isStringSmallerThan = function (config) {
    var _a, _b, _c, _d;
    var rule = config.rule;
    return !(config.value && typeof config.value === 'string' && ((_c = (_b = (_a = config.value) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > ((_d = rule.smallerThan) !== null && _d !== void 0 ? _d : 3.154e+7));
};
export var isStringLength = function (config) {
    var _a, _b;
    var rule = config.rule;
    return !(!config.value && ((_b = (_a = config.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) !== (rule === null || rule === void 0 ? void 0 : rule.length));
};
export var isRequiredValue = function (config) {
    var isRequired = isFieldRequired(config);
    return !(isRequired && !config.value);
};
export var isMatchActiveRegex = function (config) {
    var _a, _b;
    var rule = config.rule;
    return !(((_b = (_a = config.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 && !rule.activeRegex.test(config.value));
};
export var isMatchRegexClassValidator = function (config) {
    var rule = config.rule;
    return !(config.value && ((rule.regex && !rule.regex.test(config.value)) || (rule.classValidator && !rule.classValidator(config.value))));
};
export var isConfirmValid = function (config) {
    var _a;
    return !(config.key.match(confirmRegex) && config.values[config.key.match(confirmRegex)[0].toLowerCase().substring(7, (_a = config.key.match(confirmRegex)[0].toLowerCase()) === null || _a === void 0 ? void 0 : _a.length)] !== config.value);
};
//# sourceMappingURL=validators.js.map